
import { normalize_user_role } from '@/utils/system_constants/constant.js';

export default {
  name: 'UserLogin',
  components: {},
  data() {
    var data = {

    };

    return data;
  },

  mounted() {
    this.fetch_auth_token();
  },

  methods: {

    fetch_auth_token() {
      var token = this.$route.params.token;
      var user_id = this.$route.params.user_id;
      var user_role = this.$route.params.user_role;
      var is_aic_one_login = this.$route.params.is_aic_one_login;
      var current_system = this.$route.params.current_system;
      var normalized_role = normalize_user_role(user_role);

      if (token && user_id && user_role) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_id', user_id);
        sessionStorage.setItem('current_user_id', user_id);
        sessionStorage.setItem('otp_verified', true);
        sessionStorage.setItem('user_role', normalized_role);
        sessionStorage.setItem('current_role', normalized_role);
        sessionStorage.setItem('is_aic_one_login', is_aic_one_login);
        sessionStorage.setItem('current_platform', current_system);
        sessionStorage.setItem('first_time_login', 'false');

        if (is_admin_role(normalized_role)) {
          this.$router.replace({ name: 'CompanyPortfolio' });
        }
      }
      else {
        console.log("no user")
      }
    }
  }
}

function is_admin_role(role) {
  const normalized_role = String(role || '').trim().toLowerCase();
  return normalized_role.includes('admin') || normalized_role.includes('administrator');
}
